'use strict';

var Checkbox = function Checkbox() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    require: 'ngModel',
    template: require('../templates/checkbox.html'),
    scope: {},
    link: function link(scope, elem, attr, ngModelCtrl) {
      ngModelCtrl.$render = function () {
        scope.checkboxValue = ngModelCtrl.$viewValue;
      };
      scope.$watch('checkboxValue', function () {
        ngModelCtrl.$setViewValue(scope.checkboxValue);
      });
    }
  };
};
Checkbox.$inject = [];
module.exports = Checkbox;